<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-data-table
            v-bind:headers="riColumns"
            v-bind:items="itemsRI"
            :server-items-length="totalItemsRI"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            v-bind:options.sync="paginationRI"
            :loading="loading"
            :no-data-text="noDataText"
          >
            <template v-slot:item="row"
              ><tr>
                <td v-for="column in selectedRIColumns" :key="column">{{ row.item[column] }}</td>
              </tr></template
            >
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import * as TableConst from '@/mixins/table'

export default {
  data() {
    return {
      totalItemsRI: 0,
      selectedRIColumns: ['acctNo', 'name', 'suffix', 'percentage', 'curr', 'netAmt', 'locNetAmt', 'osBal', 'locOSBal'],
      riColumns: [
        { text: 'RI Company', value: 'acctNo' },
        { text: 'Name', value: 'name' },
        { text: 'Suffix', value: 'suffix' },
        { text: '%', value: 'percentage' },
        { text: 'Curr', value: 'curr' },
        { text: 'Net Amount', value: 'netAmt' },
        { text: 'Local Net Amount', value: 'locNetAmt' },
        { text: 'OS Balance', value: 'osBal' },
        { text: 'Local OS Balance', value: 'locOSBal' }
      ],
      paginationRI: {
        sortBy: [],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  mounted() {},
  methods: {},
  computed: {},
  // watch: {
  //   'paginationRI.sortDesc': function (value) {
  //     this.getRIDetails(false)
  //   },
  //   'paginationRI.page': function (value) {
  //     this.getRIDetails(false)
  //   },
  //   'paginationRI.itemsPerPage': function (value) {
  //     this.getRIDetails(false)
  //   },
  //   'paginationRI.sortBy': function (value) {
  //     this.getRIDetails(false)
  //   }
  // },
  props: {
    itemsRI: {
      type: Array,
      default: null
    }
  },
  mixins: [TableConst.default]
}
</script>
